// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_hISQoLziFgKiUTOSF5wK","Input":"SVGjZ78zUo7z_hw2BruWv","TagSearchWrap":"_1ZPBYyCIMlBieCs2iCXcXM","Suggestions":"_1Y04qt825cnWqM1bT6mv1x","Selected":"_39AYnLSjvwf-AwnOEqUUAu","SelectedTag":"_2l3w6dLEtwsMm8UcMZHPUh"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PayoutsDetailTags/styles.module.css
// module id = 565
// module chunks = 0